import Contact from "../../components/Contact/Contact"

export default function ContactMe(){
    return (
        <>
            <Contact url="contact" />
        </>
    )
}